// modules
import React from 'react';

// local
import './Chart.css';


const Chart = () =>  (
  <div className={ 'Chart__wrapper' }>
    <img className={ 'Chart__chart Chart__chart--mobile' } src={ '/_img/candlestick-mobile.gif' } alt={ 'chart' } />
      <img className={ 'Chart__chart Chart__chart--tablet' } src={ '/_img/candlestick-tablet.gif' } alt={ 'chart' } />
      <img className={ 'Chart__chart Chart__chart--desktop' } src={ '/_img/candlestick-desktop.gif' } alt={ 'chart' } />
  </div>
);

export default Chart;



// WEBPACK FOOTER //
// ./src/components/Chart/index.js